/** @jsx jsx */
import { gql } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import vegan from '../../assets/vegan.svg';
import vegetarian from '../../assets/vegetarian.svg';
import Section from '../Section/Section';

export default function ProductCertificates({ product, ...rest }) {
  const { i18n } = useLingui();
  if (!product) return null;
  const { isVegan, isVegetarian } = product;
  // We don't display 'no' values at all, so we don't need to check for false vs. null.
  if (!isVegan && !isVegetarian) return null;

  return (
    <Section title={<Trans>Certificates</Trans>} {...rest}>
      {isVegetarian && (
        <img
          src={vegetarian}
          alt={i18n._(t`Vegetarian`)}
          title={i18n._(t`Vegetarian`)}
          width="34"
          height="40"
          sx={{ marginRight: 3 }}
        />
      )}
      {isVegan && (
        <img
          src={vegan}
          alt={i18n._(t`Vegan`)}
          title={i18n._(t`Vegan`)}
          width="34"
          height="40"
          sx={{ marginRight: 3 }}
        />
      )}
    </Section>
  );
}

export const fragment = graphql`
  fragment ProductCertificates on Product {
    isVegan
    isVegetarian
  }
`;

export const ProductCertificatesFragment = gql`
  fragment ProductCertificates on Product {
    isVegan
    isVegetarian
  }
`;
